module.exports = __webpack_public_path__ + "static/media/r.c100944f.svg";